import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import {useTranslation} from 'react-i18next';

const DrawerHeader = ({title, closeDrawer}: {title: string | undefined; closeDrawer: () => void}) => {
  const {t} = useTranslation('common');

  return (
    <div style={{width: '100%'}} data-testid="drawer-header">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box flexGrow={1} p={1} m={1}>
          <Typography variant="body1" data-testid="drawer-title">
            {title}
          </Typography>
        </Box>
        <Box p={0} m={0}>
          <Tooltip title={t('close') ?? ''}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Divider orientation="vertical" light flexItem />
              <Box p={0} m={1}>
                <IconButton
                  onClick={() => {
                    closeDrawer();
                  }}
                  size="medium"
                  color="secondary"
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              </Box>
            </Stack>
          </Tooltip>
        </Box>
      </Stack>
    </div>
  );
};

export default DrawerHeader;
